<template>
    <v-input :error-messages="errors" :messages="messages" :disabled="disabled" class="chip-select-input">
        <div class="chip-select-wrapper">
            <div class="caption mb-1">{{ label }}</div>
            <div
                class="chip-select-control"
                :class="{ 'chip-select-disabled': disabled }"
                :tabindex="searchable || disabled ? -1 : 0"
                :role="searchable ? 'group' : 'combobox'"
                :aria-label="label"
                :aria-expanded="String(expanded)"
                aria-haspopup="listbox"
                @click="open"
                @keydown.enter.prevent="open"
                @keydown.space="onSpace"
            >
                <v-chip v-for="item in items" :key="item.id" small close :disabled="disabled"
                    @click.stop="open" @click:close="$emit('remove', item.id)" class="chip-select-chip">
                    {{ item.name || item.text }}
                </v-chip>
                <input v-if="searchable" :value="search" :disabled="disabled" :aria-label="label"
                    :aria-expanded="String(expanded)" aria-autocomplete="list" role="combobox"
                    :placeholder="placeholder" class="chip-select-search"
                    @input="$emit('update:search', $event.target.value)" @focus="open"
                    @keydown.esc.stop="$emit('close')" @keydown.down.prevent="open" />
                <span v-else-if="!items.length" class="grey--text chip-select-placeholder">{{ placeholder }}</span>
                <v-spacer />
                <v-progress-circular v-if="loading" indeterminate size="18" width="2" class="mx-2" />
                <v-btn icon small :disabled="disabled" :aria-label="'Открыть: ' + label" @click.stop="open">
                    <v-icon>mdi-chevron-down</v-icon>
                </v-btn>
            </div>
        </div>
    </v-input>
</template>

<script>
export default {
    name: 'ChipSelectField',
    props: {
        items: { type: Array, default: () => [] },
        label: { type: String, required: true },
        placeholder: { type: String, default: 'Выберите значения' },
        errors: { type: Array, default: () => [] },
        messages: { type: [String, Array], default: '' },
        search: { type: String, default: '' },
        searchable: Boolean, disabled: Boolean, loading: Boolean, expanded: Boolean,
    },
    methods: {
        open () { if (!this.disabled) this.$emit('open') },
        onSpace (event) {
            if (!this.searchable) { event.preventDefault(); this.open() }
        },
    },
}
</script>

<style scoped>
.chip-select-wrapper { width: 100%; }
.chip-select-control { display: flex; flex-wrap: wrap; align-items: center; gap: 6px; min-height: 44px; padding: 6px 8px; border: 1px solid #9e9e9e; border-radius: 4px; cursor: pointer; }
.chip-select-control:focus, .chip-select-control:focus-within { outline: 2px solid #1976d2; outline-offset: -1px; }
.chip-select-search { flex: 1 1 140px; width: 140px; min-width: 80px; padding: 4px; outline: none; }
.chip-select-disabled { background: #f5f5f5; cursor: default; opacity: .65; }
.chip-select-chip.v-chip { height: auto; min-height: 24px; max-width: 100%; }
.chip-select-chip ::v-deep .v-chip__content { height: auto; white-space: normal; padding: 3px 0; }
.chip-select-placeholder { padding-left: 4px; }
</style>
